import { useLocation, useNavigate, useParams } from "react-router-dom";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { useEffect, useState } from "react";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import DocumentIcon from "../../../components/Icons/DocumentIcon";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import {
  checkUserAccess,
  formatTo12HourTime,
  handleAttendanceStatus,
  handleStatus,
  UserTypeHandler,
} from "../../../utility/CommonFunctions";
import moment from "moment";
import { useSelector } from "react-redux";
import Logs from "../../Logs/Logs";

export default function ArRequestDetail() {
  let { id } = useParams();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const [ArDetail, setArDetail] = useState({});
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [refreshLogs, setRefreshLogs] = useState(false);

  useEffect(() => {
    GetArDetail();
  }, []);

  const GetArDetail = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl?.get_ar_detail + `?attendanceId=${id}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        setArDetail(response?.data);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleDocumentClick = (item) => {
    const docUrl = {
      url: item?.url,
    };
    setSelectedDocument(docUrl);
    setModal(true);
  };

  const renderDocument = () => {
    if (!selectedDocument) return null;

    // console.log(selectedDocument);

    const fileExtension = selectedDocument?.document
      ?.split(".")
      ?.pop()
      ?.toLowerCase();

    // console.log(fileExtension);

    switch (fileExtension) {
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
        return (
          <img
            src={selectedDocument?.document}
            alt="Document Preview"
            style={{ maxWidth: "100%", maxHeight: "500px" }}
          />
        );
      case "pdf":
        return (
          <iframe
            src={selectedDocument?.document}
            width="100%"
            height="500px"
            title="Document Preview"
          ></iframe>
        );
      case "txt":
        return (
          <textarea
            readOnly
            value={selectedDocument?.content} // Assuming `content` is the file content
            style={{ width: "100%", height: "500px" }}
          />
        );
      case "docx":
        return (
          <div>
            {
              / Handle DOCX preview (you can integrate a library like `react-doc-viewer`) /
            }
            <p>DOCX preview not supported in browser directly.</p>
          </div>
        );
      default:
        return <p>Unsupported file type</p>;
    }
  };

  const uniqueSiteTypes = [
    ...new Set(
      ArDetail?.user?.usersites?.map((item) => item.site.type).filter(Boolean)
    ),
  ];

  const HandleApprove_Reject = (type) => {
    let newStatus;
    if (type == "approve") {
      newStatus = 1;
    } else if (type == "reject") {
      newStatus = 2;
    }
    const submitData = {
      type: "arRequest",
      id: ArDetail?.id,
      status: newStatus,
    };
    // console.log("submitData>>>>", submitData);
    const options = {
      method: "POST",
      data: submitData,
    };
    let API = apiUrl?.user_status_update;
    callApi(API, options).then((response) => {
      if (response?.status === true) {
        toast.success(response?.message);
        GetArDetail();
        setRefreshLogs(true);
      } else {
        toast.error(response?.message);
      }
    });
  };

  return (
    <>
      <>
        <div className="content container-fluid">
          <div className="content-head mb-5 d-flex align-items-start justify-content-between">
            <div className="d-flex align-items-center justify-content-start gap-4">
              <button className="btn back-arrow" onClick={() => navigate(-1)}>
                <BackArrowIcon />
              </button>
              <h1 className="mb-0">A.R. Detail</h1>
            </div>
          </div>
          <div className="card manage-user-list">
            <div className="card-body">
              <ul
                className={
                  isLoading
                    ? "row list-unstyled mt-4 loading-skeleton"
                    : "row list-unstyled mt-4"
                }
              >
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Emp. Code :-
                    </span>
                    {ArDetail?.user?.employeeCode}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Emp. Name :-
                    </span>
                    {ArDetail?.user?.name}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Emp. Dept. :-
                    </span>
                    {ArDetail?.user?.department?.name}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Emp. Designation :-
                    </span>
                    {ArDetail?.user?.designation?.name}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Attendance :-
                    </span>
                    {handleAttendanceStatus(ArDetail?.status) || "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Status :-</span>
                    {handleStatus(ArDetail?.arRequestStatus) || "--"}
                  </p>
                </li>

                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Applied On :-
                    </span>
                    {(ArDetail?.createdAt &&
                      moment(ArDetail?.createdAt).format("DD/MM/YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Start Date :-
                    </span>
                    {(ArDetail?.createdAt &&
                      moment(ArDetail?.checkInTime).format("DD/MM/YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">End Date :-</span>
                    {(ArDetail?.createdAt &&
                      moment(ArDetail?.checkOutTime).format("DD/MM/YYYY")) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Check In :-</span>
                    {(ArDetail?.checkInTime &&
                      ArDetail?.checkInTime &&
                      formatTo12HourTime(ArDetail?.checkInTime)) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Check Out :-
                    </span>
                    {(ArDetail?.checkOutTime &&
                      ArDetail?.checkOutTime &&
                      formatTo12HourTime(ArDetail?.checkOutTime)) ||
                      "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      {ArDetail?.user?.type == 1 && " Office :-"}
                      {ArDetail?.user?.type == 0 && " Site :-"}
                    </span>
                    {ArDetail?.user?.type == 1
                      ? ArDetail?.user?.site?.name
                      : ArDetail?.user?.type == 0
                        ? ArDetail?.user?.usersites?.[0]?.site?.name
                        : "--"}
                  </p>
                </li>
                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">Reason :-</span>
                    {ArDetail?.Arrequests?.[0]?.reason || "--"}
                  </p>
                </li>

                <li className="col-12 col-md-6 col-lg-4">
                  <p>
                    <span className="text-muted fs-5 d-block">
                      Site Type :-
                    </span>
                    {uniqueSiteTypes.join(", ")}
                  </p>
                </li>
                {/* {ArDetail?.status == 0 && ( */}
                {((checkUserAccess(userDetails).isUserAccess &&
                  location?.state?.type === "request" &&
                  userDetails?.type !== 2) ||
                  location?.state?.type === "teamRequest") && (
                    <div className="card-body d-flex justify-content-end">
                      <div className="col-12 col-md-6 col-lg-4 ">
                        <span className="d-flex align-items-center gap-3 justify-content-end">
                          <>
                            <button
                              className="btn btn-success "
                              onClick={() => HandleApprove_Reject("approve")}
                              disabled={ArDetail?.arRequestStatus == 1}
                            >
                              Approve
                            </button>
                            <button
                              className="btn btn-danger px-4"
                              onClick={() => HandleApprove_Reject("reject")}
                              disabled={ArDetail?.arRequestStatus == 2}
                            >
                              Reject
                            </button>
                          </>
                        </span>
                      </div>
                    </div>
                  )}
                {/* )} */}
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-12 ">
              <div className="card manage-user-list">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between border-bottom mb-3">
                    <h4 className="d-flex align-items-center mb-4">
                      Documents
                    </h4>
                  </div>
                  <ul className="row list-unstyled gap-3">
                    {/* {ArDetail?.documents?.length > 0 ? (
                                            employeeDetail?.documents?.map((doc, index) => {
                                            return ( */}
                    <li className="col-12">
                      <div
                        className="text-muted fs-5 d-flex gap-2 text-decoration-none"
                        onClick={() =>
                          handleDocumentClick(ArDetail?.Arrequests?.[0])
                        }
                        role="button"
                      >
                        <DocumentIcon />
                        Document
                      </div>
                    </li>
                    {/* );
                                         })
                                             ) : (
                                             <div>No Document Found</div>
                                        )} */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Logs
          type={"arRequest"}
          id={id}
          refreshLogs={refreshLogs}
          setRefreshLogs={setRefreshLogs}
        />
      </>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        renderDocument={renderDocument}
      />
    </>
  );
}
